import { render, staticRenderFns } from "./LobbyNavbar.vue?vue&type=template&id=64d96302&scoped=true&"
import script from "./LobbyNavbar.vue?vue&type=script&lang=js&"
export * from "./LobbyNavbar.vue?vue&type=script&lang=js&"
import style0 from "./LobbyNavbar.vue?vue&type=style&index=0&id=64d96302&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d96302",
  null
  
)

export default component.exports